import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiagramProject, faChevronDown, faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import ProjectConfig from "@serie3/freelancesplaceapi/Config/Projects/ProjectConfig";
import crudApi from "@serie3/common/api/crudApi";
import { useEffect, useState, forwardRef } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

const QuickToggle = forwardRef(({ onClick }, ref) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      ref={ref}
      onClick={(e) => { e.preventDefault(); onClick(e); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex", alignItems: "center", gap: "6px",
        padding: "6px 12px", borderRadius: "8px",
        background: hovered ? "#e8f0fe" : "#f0f4ff",
        border: "none", cursor: "pointer",
        color: "#1a73e8", fontWeight: 600, fontSize: "0.85rem",
        transition: "background 0.15s",
      }}
    >
      <FontAwesomeIcon icon={faDiagramProject} style={{ fontSize: "0.85rem" }} />
      Projects
      <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: "0.6rem", opacity: 0.7 }} />
    </button>
  );
});

const ProjectQuicklink = () => {
  const [quicklinks, setQuickLinks] = useState([]);

  useEffect(() => {
    crudApi.getAll(ProjectConfig.endpoints.quickLinks, setQuickLinks, "project");
  }, []);

  if (quicklinks.length === 0) return null;

  return (
    <Dropdown as="li" style={{ listStyle: "none" }}>
      <Dropdown.Toggle as={QuickToggle} />
      <Dropdown.Menu
        style={{
          borderRadius: "12px",
          boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
          border: "1px solid #f0f0f0",
          padding: "8px",
          minWidth: "220px",
          marginTop: "6px",
        }}
        popperConfig={{ strategy: "fixed" }}
        renderOnMount
      >
        <div style={{ padding: "4px 12px 8px", fontSize: "0.68rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e" }}>
          Quick Access
        </div>
        {quicklinks.map((link, index) => (
          <Dropdown.Item
            key={index}
            as={Link}
            to={"/project/edit/" + link.id}
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "9px 12px", borderRadius: "8px",
              fontSize: "0.88rem", fontWeight: 500, color: "#424242",
              textDecoration: "none",
            }}
          >
            <span style={{
              overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1,
            }}>
              {link.title}
            </span>
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: "0.65rem", color: "#bdbdbd", marginLeft: "8px", flexShrink: 0 }} />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProjectQuicklink;
